const url = import.meta.env.VITE_APP_API_NEWS
const imgPath = import.meta.env.VITE_APP_API_SOURCE
export default {
    actions: {
        fetchNews: async ({ commit, rootGetters }) => {
            commit("SET_LOADING_STATUS", true)
            const  resJson = await fetch(`${url}/article-list`, {
                headers: {"Content-Type": "application/json", "Accept-Language": rootGetters["app/getLanguage"]}
            })
            const res = await resJson.json()
            if(res.code === 200) {
                commit("SET_NEWS", res.data)
                commit("SET_LOADING_STATUS", false)
                return res.data.items
            }
            commit("SET_LOADING_STATUS", false)
        },
    },
    mutations: {
        SET_NEWS(state, list) {
            list.items = list.items .filter(item => item.image !== "").map(item => {
                return {
                    ...item,
                    image: `${imgPath}${item.image}`
                };
            });
            state.newsList = list
        },
        SET_LOADING_STATUS(state, status) {
            state.newsLoadingStatus = status
        },
    },
    state: {
        newsList: {
            pagination: [],
            items: []
        },
        newsLoadingStatus: undefined
    },
    getters: {
        getNewsList:(state) => state.newsList,
        getNewsLoadingStatus:(state) => state.newsLoadingStatus,

    }
}